import { store } from '../../components/cascader/store';
import config from '../../config';
import MyWorker from './address.worker.js';

const defaultFetch = () => {
  const { provinceUrl, cityUrl, countyUrl, alias } = config.get().address;
  return fetchData(provinceUrl, cityUrl, countyUrl, alias);
};

const fetchData = (provinceUrl, cityUrl, countyUrl, alias) => {
  let provinceres, cityres, countyres;
  provinceres = rt.get(provinceUrl);
  cityres = rt.get(cityUrl);
  countyres = rt.get(countyUrl);
  let { id, name } = alias;
  return Promise.all([provinceres, cityres, countyres]).then(res => {
    let provincelist, citylist, countylist;
    provincelist = res[0].slice();
    citylist = res[1].slice();
    countylist = res[2].slice();

    // 获取省市县数据和构建省市县组件数据结构属于耗时操作，使用 worker 防止阻塞主线程
    // webpack中使用worker需要使用worker-loader
    let worker = new MyWorker();
    worker.postMessage({ provincelist, citylist, countylist, id, name });

    return new Promise(resolve => {
      worker.addEventListener('message', event => {
        let addressData = event.data;
        resolve(addressData);
      });
    });
  });
};
export default {
  name: 'addressPlugin',

  // 插件是否自动安装
  autoInstall: true,

  fetch: null,
  install (Vue) {
    Vue.prototype.$address = Vue.address = this;

    const { autoLoad } = config.get().address;
    // 初始化省市县数据
    autoLoad && this.getAddressData();
  },
  resetFetch (fn = null) {
    this.fetch = fn;
    this.fetch && this.getAddressData();
  },
  getAddressData () {
    let fetchMethod = this.fetch || defaultFetch;
    fetchMethod()
      .then(res => {
        store.updateAddress(res);
      })
      .catch(err => {
        rt.showErrorToast(err);
      });
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/address/index.js